import { useCurrentLocale } from '@blofin/blofin-utils';

export default function useLocaleLink() {
  const { localeLink } = useCurrentLocale();
  return localeLink || '/en';
}
